import { gql } from '@apollo/client'

export const GET_ALL_PUBLIC_LOTS = gql`
    query booking_get_public_lots {
        booking_get_public_lots {
            lots
        }
    }
`
